import * as React from 'react';
import {connect} from 'react-redux';
import {FeatureGroup, GeoJSON, Marker} from 'react-leaflet';
import MapUtils from "../../../../map/map-utils";
import {dataforvalterMapConfig} from "../../../../map/map-config";
import {
    NvdbFeature, UserSession
} from "../../domain";
import WKTParser from 'terraformer-wkt-parser';
import FeaturesState from "../../domain/FeaturesState";
import * as geojson from "geojson";
import MarkerClusterGroup from "react-leaflet-markercluster";
import {showImportNvdbRoadObjectModal, ShowImportNvdbRoadObjectModal} from "../../reducers/actions";

interface StateProps {
    existingFeatures: Array<NvdbFeature>;
    user: UserSession;
}

interface DispatchProps {
    doShowImportNvdbRoadObjectModal: ShowImportNvdbRoadObjectModal;
}

type Props = StateProps & DispatchProps;

interface ExistingFeaturesState {
}

class ExistingFeatures extends React.Component<Props, ExistingFeaturesState> {

    constructor(props: Props) {
        super(props);
    }

    render() {
        const {existingFeatures} = this.props;

        // Map existing features. Points must be mapped separately to work with both clustering an popup
        let markers: React.ReactElement[] = [];
        let geoJson: React.ReactElement[] = [];
        existingFeatures.forEach(existingFeature => {
            let featurePositionApi = WKTParser.parse(existingFeature.geometry.wkt);

            if (featurePositionApi.type === "Point") {
                markers.push(this.pointToMarker((featurePositionApi as geojson.Point).coordinates, existingFeature))
            } else if (featurePositionApi.type === "MultiPoint") {
                (featurePositionApi as geojson.MultiPoint).coordinates.forEach(point => {
                    markers.push(this.pointToMarker(point, existingFeature));
                })
            } else {
                let geometryWithSwappedPositions = MapUtils.swapLatLong(featurePositionApi);
                geoJson.push(
                    <GeoJSON data={geometryWithSwappedPositions}
                             style={dataforvalterMapConfig.STYLES.existingObjectsStyle}
                             key={existingFeature.id}
                             onClick={() => this.props.doShowImportNvdbRoadObjectModal(existingFeature)}
                    >
                    </GeoJSON>
                )
            }
        });

        // Render to React-Leaflet feature group
        return (
            <FeatureGroup>
                {geoJson}
                {markers.length > 0 &&
                    <MarkerClusterGroup>
                        {markers}
                    </MarkerClusterGroup>
                }
            </FeatureGroup>
        )
    }

    private pointToMarker(point: geojson.Position, existingFeature: NvdbFeature): React.ReactElement {
        let pos: L.LatLngLiteral = {lat: point[0], lng: point[1]};
        return(
            <Marker position={pos} key={existingFeature.id} onClick={() => this.props.doShowImportNvdbRoadObjectModal(existingFeature)} />
        )
    }
}

const mapStateToProps = (state: FeaturesState): StateProps => {
    return {
        existingFeatures: state.existingFeatures,
        user: state.user,
    };
};
const mapDispatchToProps: DispatchProps = ({
    doShowImportNvdbRoadObjectModal: showImportNvdbRoadObjectModal,
});
export default connect(mapStateToProps, mapDispatchToProps)(ExistingFeatures);
